import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { FrequencyInputSelect } from "./priority/FrequencyInputSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const FrequencyInputItem = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("priority");

  if (config && (config?.hidden || config?.frequency?.length === 0))
    return <></>;

  const label = t("maintenance:ticket.create.priority.frequency.label");
  return (
    <Form.Item<SaveTicketValues> name="frequency" label={label} {...props}>
      {props.type === "dropdown" ? <FrequencyInputSelect /> : null}
    </Form.Item>
  );
});
